import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../types';
import api from '../../services/api';
import { modal } from '../../components/Base/Modal';

export function* getReset2FA({ body }) {
  try {
    const { data, status } = yield call(api.reset_2FA.getUsersReset2FA, body);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.GET_RESET_2FA_MESSAGE_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    console.error(error);
    yield put({ type: types.GET_RESET_2FA_MESSAGE_FAILURE });
  }
}

export function* putResetRequest2FA({ payload }) {
  try {
    const { data, status } = yield call(api.reset_2FA.putResetRequest2FA, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.APPROVE_2FA_SUCCESS,
      payload: data,
    });
    modal.close();
    yield put({ type: types.GET_RESET_2FA_MESSAGE_START });
  } catch (error) {
    console.error(error);
    yield put({ type: types.APPROVE_2FA_FAILURE });
  }
}

export function* postRejectRequest2FA({ payload }) {
  try {
    const { data, status } = yield call(api.reset_2FA.postRejectRequest2FA, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.REJECT_2FA_SUCCESS,
      payload: data,
    });
    modal.close();
    yield put({ type: types.GET_RESET_2FA_MESSAGE_START });
  } catch (error) {
    console.error(error);
    yield put({ type: types.REJECT_2FA_FAILURE });
  }
}

export function* reset2FA() {
  yield all([
    takeLatest(types.GET_RESET_2FA_MESSAGE_START, getReset2FA),
    takeLatest(types.APPROVE_2FA_START, putResetRequest2FA),
    takeLatest(types.REJECT_2FA_START, postRejectRequest2FA),
  ]);
}
